import IconTicketWithQR from "@Icons/tripSummaryIcons/IconTicketWithQR";
import {Colors} from "@Styles/Colors.style";
import IconDistance from "@Icons/IconDistance";
import IconMorning from "@Icons/searchRes/filters/IconMorning";
import IconEvening from "@Icons/searchRes/filters/IconEvening";
import IconHourglass from "@Icons/iconLibrary/IconHourglass";
import IconLocationMarker from "@Icons/IconLocationMarker";
import {useTranslation} from "@Translation/hooks/useTranslation";

interface TravelTableHeaderProps {
    setHoveredColumnIndex: (index: number) => void;
}

export const TravelTableHeader = (props: TravelTableHeaderProps) => {
    const {
        setHoveredColumnIndex,
    } = props;

    return (
        <thead>
            <tr>
                <th className="travel-table-icons"/>
                <th
                    onMouseOver={() => {
                        setHoveredColumnIndex(2)
                    }}
                >
                    <IconTicketWithQR
                        width={18}
                        height={18}
                        outline={Colors.primaryColor}
                    />
                    {useTranslation("travel_page.travel_options_section.lowest_price")}
                </th>
                <th
                    onMouseOver={() => {
                        setHoveredColumnIndex(3)
                    }}
                >
                    <IconTicketWithQR
                        width={18}
                        height={18}
                        outline={Colors.primaryColor}
                    />
                    {useTranslation("travel_page.travel_options_section.average_price")}
                </th>
                <th
                    onMouseOver={() => {
                        setHoveredColumnIndex(4)
                    }}
                >
                    <IconDistance width={18} height={18}/>
                    {useTranslation("travel_page.travel_options_section.daily_departures")}
                </th>
                <th
                    onMouseOver={() => {
                        setHoveredColumnIndex(5)
                    }}
                >
                    <IconMorning fill={Colors.primaryColor}/>
                    {useTranslation("travel_page.travel_options_section.earliest_departure")}
                </th>
                <th
                    onMouseOver={() => {
                        setHoveredColumnIndex(6)
                    }}
                >
                    <IconEvening fill={Colors.primaryColor}/>
                    {useTranslation("travel_page.travel_options_section.latest_departure")}
                </th>
                <th
                    onMouseOver={() => {
                        setHoveredColumnIndex(7)
                    }}
                >
                    <IconHourglass fill={'transparent'} width={16} height={16} outline={Colors.primaryColor}/>
                    {useTranslation("travel_page.travel_options_section.average_travel_time")}
                </th>
                <th
                    onMouseOver={() => {
                        setHoveredColumnIndex(8)
                    }}
                >
                    <IconLocationMarker
                        width={14}
                        height={14}
                        fill={Colors.primaryColor}
                    />
                    {useTranslation("travel_page.travel_options_section.departure_station")}
                </th>
                <th
                    onMouseOver={() => {
                        setHoveredColumnIndex(9)
                    }}
                >
                    <IconLocationMarker
                        width={14}
                        height={14}
                        fill={Colors.primaryColor}
                    />
                    {useTranslation("travel_page.travel_options_section.destination_station")}
                </th>
                <th
                    onMouseOver={() => {
                        setHoveredColumnIndex(10)
                    }}
                >
                    {useTranslation("travel_page.travel_options_section.popular_operators")}
                </th>
                <th
                    onMouseOver={() => {
                        setHoveredColumnIndex(11)
                    }}
                >
                    {useTranslation("travel_page.travel_options_section.combined_transport")}
                </th>
            </tr>
        </thead>
    )
}